/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { CART_ITEM_FRAGMENT } from './CartItemFragment';
import { APPLIED_GIFT_CARDS_FRAGMENT } from '../fragments';

export const CART_FRAGMENT = /* GraphQL */ `
  fragment CART_FRAGMENT on Cart {
    id
    total_quantity
    is_virtual
    applied_gift_cards {
      ...APPLIED_GIFT_CARDS_FRAGMENT
    }
    gift_receipt_included
    printed_card_included
    gift_message {
      ...GIFT_MESSAGE_FRAGMENT
    }
    gift_wrapping {
      ...GIFT_WRAPPING_FRAGMENT
    }
    available_gift_wrappings {
      ...AVAILABLE_GIFT_WRAPPING_FRAGMENT
    }
    prices {
      gift_options {
        gift_wrapping_for_items {
          currency
          value
        }
        gift_wrapping_for_items_incl_tax {
          currency
          value
        }
        gift_wrapping_for_order {
          currency
          value
        }
        gift_wrapping_for_order_incl_tax {
          currency
          value
        }
        printed_card {
          currency
          value
        }
        printed_card_incl_tax {
          currency
          value
        }
      }
      subtotal_with_discount_excluding_tax {
        currency
        value
      }
      subtotal_including_tax {
        currency
        value
      }
      subtotal_excluding_tax {
        currency
        value
      }
      grand_total {
        currency
        value
      }
      grand_total_excluding_tax {
        currency
        value
      }
      applied_taxes {
        label
        amount {
          value
          currency
        }
      }
      discounts {
        amount {
          value
          currency
        }
        label
        coupon {
          code
        }
        applied_to
      }
    }
    applied_coupons {
      code
    }
    itemsV2(
      pageSize: $pageSize
      currentPage: $currentPage
      sort: $itemsSortInput
    ) {
      items {
        ...CART_ITEM_FRAGMENT
      }
    }
    shipping_addresses {
      country {
        code
      }
      region {
        code
      }
      postcode
    }
  }

  ${CART_ITEM_FRAGMENT}
  ${APPLIED_GIFT_CARDS_FRAGMENT}
`;
